// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Painel de exploração territorial premium.
 *
 * Especificações:
 *   - Verde institucional profundo, cobrindo toda a altura do mapa.
 *   - Mapa permanece montado durante toda a navegação contextual.
 *   - Cartões premium para catálogo, lista de feições e atributos.
 *   - Estruturalmente preparado para modos temporais sem renderizá-los.
 */

.painel-exploracao {
  position: absolute;
  z-index: 6;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(var(--largura-exploracao), 100%);
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: linear-gradient(
      180deg,
      var(--painel-exploracao-fundo) 0%,
      var(--painel-exploracao-fundo-2) 100%
    );
  color: var(--tinta-invertida);
  border-left: 1px solid var(--painel-exploracao-linha);
  box-shadow: -8px 0 24px rgba(15, 35, 26, 0.18);
  overflow: hidden;
}

.painel-exploracao__corpo {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0 var(--espaco-4) var(--espaco-4);
  scrollbar-gutter: stable;
}

.painel-exploracao__rodape {
  flex: none;
  padding: var(--espaco-3) var(--espaco-4);
  border-top: 1px solid var(--painel-exploracao-linha);
  background: rgba(0, 0, 0, 0.18);
}

/* --- Cabeçalho do painel ------------------------------------------------ */

.exploracao__cabecalho {
  flex: none;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: var(--espaco-3);
  padding: var(--espaco-4) var(--espaco-5);
  border-bottom: 1px solid var(--painel-exploracao-linha);
  background: rgba(0, 0, 0, 0.12);
}

.exploracao__voltar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: var(--raio);
  color: var(--tinta-invertida);
  cursor: pointer;
  transition: background var(--transicao);
}

.exploracao__voltar:hover {
  background: rgba(255, 255, 255, 0.16);
}

.exploracao__voltar svg {
  width: 14px;
  height: 14px;
}

.exploracao__titulos {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.exploracao__rotulo {
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  margin: 0;
  font-size: var(--texto-xs);
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.62);
}

.exploracao__rotulo svg {
  width: 14px;
  height: 14px;
}

.exploracao__titulo {
  margin: 0;
  font-size: var(--texto-lg);
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--tinta-invertida);
}

.exploracao__acoes {
  display: flex;
  align-items: center;
  gap: var(--espaco-1);
  margin-left: auto;
}

.exploracao__acao {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 var(--espaco-2);
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: var(--raio);
  color: rgba(255, 255, 255, 0.86);
  cursor: pointer;
  font-size: var(--texto-md);
  transition: background var(--transicao), color var(--transicao);
}

.exploracao__acao:hover {
  background: rgba(255, 255, 255, 0.12);
  color: var(--tinta-invertida);
}

/* --- Níveis genéricos --------------------------------------------------- */

.nivel {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-4);
  padding-top: var(--espaco-4);
}

.nivel__cabecalho-utilitario {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--espaco-2);
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.055);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
}

.nivel__contador {
  margin: 0;
  color: rgba(255, 255, 255, 0.76);
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.nivel__botao-icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--raio);
  color: rgba(255, 255, 255, 0.82);
  cursor: pointer;
  transition: background var(--transicao);
}

.nivel__botao-icone:hover {
  background: rgba(255, 255, 255, 0.1);
}

.nivel__botao-icone:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.nivel__rodape-acoes {
  display: flex;
  justify-content: flex-end;
  gap: var(--espaco-2);
  padding: var(--espaco-3) 0 var(--espaco-2);
}

/* --- Cartão premium de camada ------------------------------------------ */

.lista-cartoes {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--espaco-4);
}

/* Superfície única dos cartões do painel (catálogo, ficha da camada, lista, inspeção). */
.cartao-camada {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: var(--espaco-4);
  background: rgba(255, 255, 255, 0.065);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: var(--raio-grande);
  color: #ffffff;
  transition: background var(--transicao), border-color var(--transicao);
}

.cartao-camada:hover {
  background: rgba(255, 255, 255, 0.105);
}

.cartao-camada[data-selecionado='sim'] {
  background: rgba(255, 255, 255, 0.145);
  border-color: rgba(245, 220, 132, 0.58);
}

/* Área A — identificação. */
.cartao-camada__cabecalho {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  min-height: 32px;
}

.cartao-camada__amostra {
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  cursor: pointer;
}

.cartao-camada__amostra input {
  width: 14px;
  height: 14px;
  accent-color: #f5dc84;
  cursor: pointer;
}

.cartao-camada__nome {
  display: -webkit-box;
  min-width: 0;
  text-align: left;
  background: none;
  border: none;
  padding: 0;
  color: #ffffff;
  font: inherit;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.35;
  cursor: pointer;
  overflow: hidden;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  transition: color var(--transicao);
}

.cartao-camada__nome:hover {
  color: #f5dc84;
}

.cartao-camada__quantidade {
  flex: none;
  font-family: var(--fonte-dados);
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: rgba(255, 255, 255, 0.76);
  padding: 2px var(--espaco-2);
  background: rgba(0, 0, 0, 0.18);
  border-radius: 999px;
}

.cartao-camada__expandir {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: var(--raio);
  color: rgba(255, 255, 255, 0.76);
  cursor: pointer;
  transition: transform var(--transicao), background var(--transicao);
}

.cartao-camada__expandir:hover {
  background: rgba(255, 255, 255, 0.105);
  color: #ffffff;
}

.cartao-camada[data-expandido='sim'] .cartao-camada__expandir {
  transform: rotate(90deg);
}

.cartao-camada__estado {
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  font-size: 11px;
  color: rgba(255, 255, 255, 0.76);
}

.cartao-camada__estado--erro {
  color: #f5b3ad;
}

.cartao-camada__estado--aviso {
  color: #f5dc84;
}

.cartao-camada__estado--carregando {
  color: rgba(255, 255, 255, 0.76);
}

/* Área B — ações. */
.cartao-camada__acoes {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--espaco-2);
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.09);
}

.cartao-camada__botao {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--espaco-2);
  min-height: 34px;
  padding: 0 var(--espaco-3);
  border-radius: var(--raio);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background var(--transicao), border-color var(--transicao), color var(--transicao);
  border: 1px solid transparent;
}

.cartao-camada__botao svg {
  width: 12px;
  height: 12px;
}

.cartao-camada__botao--primario {
  background: #f5dc84;
  border-color: #f5dc84;
  color: #123f2b;
}

.cartao-camada__botao--primario:hover {
  background: #f0d468;
  border-color: #f0d468;
  color: #123f2b;
}

.cartao-camada__botao--secundario {
  background: rgba(255, 255, 255, 0.065);
  border-color: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.94);
}

.cartao-camada__botao--secundario:hover {
  background: rgba(255, 255, 255, 0.105);
  border-color: rgba(255, 255, 255, 0.3);
}

.cartao-camada__botao--discreto {
  min-width: 34px;
  background: transparent;
  border-color: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.76);
  margin-left: auto;
}

.cartao-camada__botao--discreto:hover {
  background: rgba(255, 255, 255, 0.105);
  color: #ffffff;
}

.cartao-camada__botao:focus-visible,
.cartao-camada__nome:focus-visible,
.cartao-camada__expandir:focus-visible {
  outline: 2px solid #f5dc84;
  outline-offset: 2px;
}

/* Área C — expansão. */
.cartao-camada__expansao {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: var(--espaco-3);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.cartao-camada__expansao .configuracao-da-camada {
  border-color: rgba(255, 255, 255, 0.16);
}

.cartao-camada__expansao .configuracao-da-camada__grupo legend {
  color: rgba(255, 255, 255, 0.74);
}

.cartao-camada__expansao .configuracao-da-camada__grupo fieldset,
.cartao-camada__expansao .configuracao-da-camada__grupo > label {
  color: rgba(255, 255, 255, 0.86);
}

.cartao-camada__expansao .botao--texto {
  color: #f5dc84;
}

/* --- Painel seccionado (Relevo e ferramentas) --------------------------- */

.painel-seccionado {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-3);
  padding: var(--espaco-4);
  background: rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: var(--raio-grande);
}

.painel-seccionado__cabecalho {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.painel-seccionado__titulo {
  margin: 0;
  font-size: var(--texto-md);
  font-weight: 700;
  color: var(--tinta-invertida);
  letter-spacing: -0.01em;
}

.painel-seccionado__subtitulo {
  margin: 0;
  font-size: var(--texto-xs);
  color: rgba(255, 255, 255, 0.66);
}

/* --- Ordem no mapa ------------------------------------------------------ */

.ordem-camadas {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-3);
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.065);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 12px;
}

.ordem-camadas__cabecalho {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ordem-camadas__titulo {
  margin: 0;
  font-size: var(--texto-md);
  font-weight: 700;
  color: var(--tinta-invertida);
}

.ordem-camadas__subtitulo {
  margin: 0;
  font-size: var(--texto-xs);
  color: rgba(255, 255, 255, 0.66);
}

.ordem-camadas__lista {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.ordem-camadas__item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 6px 8px;
  background: rgba(0, 0, 0, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
}

.ordem-camadas__nome {
  flex: 1 1 auto;
  min-width: 0;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.ordem-camadas__botao {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: var(--raio);
  color: rgba(255, 255, 255, 0.82);
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  transition: background var(--transicao), color var(--transicao);
}

.ordem-camadas__botao:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.105);
  color: #ffffff;
}

.ordem-camadas__botao:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.ordem-camadas__botao:focus-visible {
  outline: 2px solid #f5dc84;
  outline-offset: 2px;
}

/* --- Exploração de camada ---------------------------------------------- */

.ficha-camada {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: var(--espaco-4);
  background: rgba(255, 255, 255, 0.065);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: var(--raio-grande);
}

.ficha-camada__cabecalho {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--espaco-3);
}

.ficha-camada__titulos {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ficha-camada__rotulo {
  margin: 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
}

.ficha-camada__titulo {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.3;
  overflow-wrap: anywhere;
  color: #ffffff;
}

.ficha-camada__contador {
  flex: none;
  font-family: var(--fonte-dados);
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  padding: 2px var(--espaco-2);
  background: rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  color: rgba(255, 255, 255, 0.76);
}

.ficha-camada__descricao {
  margin: 0;
  color: rgba(255, 255, 255, 0.76);
  font-size: 12px;
  line-height: 1.55;
}

.ficha-camada__descricao + .ficha-camada__descricao {
  margin-top: var(--espaco-2);
}

.ficha-camada__acoes {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  align-items: stretch;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.09);
}

.ficha-camada__acoes > .botao {
  display: inline-flex;
  width: 100%;
  min-width: 0;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px;
  margin: 0;
  text-align: center;
  line-height: 1.3;
  white-space: normal;
  border-radius: var(--raio);
  font-size: 12px;
  font-weight: 600;
}

.ficha-camada__acoes .botao svg {
  width: 12px;
  height: 12px;
}

.ficha-camada__acoes .botao--secundario {
  background: rgba(255, 255, 255, 0.065);
  border-color: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.94);
}

.ficha-camada__acoes .botao--secundario:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.105);
  border-color: rgba(255, 255, 255, 0.3);
  color: #ffffff;
}

.ficha-camada__acoes .botao--discreto {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.76);
}

.ficha-camada__acoes .botao--discreto:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.105);
  color: #ffffff;
}

.ficha-camada__acoes .botao:focus-visible {
  outline: 2px solid #f5dc84;
  outline-offset: 2px;
}

/* --- Sobrescrita do SeletorDeFeicoes para combinar com o painel --------- */

.nivel--exploracao .seletor-de-feicoes {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: var(--espaco-4);
  background: rgba(255, 255, 255, 0.065);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: var(--raio-grande);
}

.nivel--exploracao .seletor-de-feicoes .camadas__alternador {
  color: rgba(255, 255, 255, 0.86);
}

.nivel--exploracao .seletor-de-feicoes .busca .campo__entrada {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
  color: var(--tinta-invertida);
}

.nivel--exploracao .seletor-de-feicoes .busca .campo__entrada::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.nivel--exploracao .seletor-de-feicoes .busca__icone {
  color: rgba(255, 255, 255, 0.62);
}

.nivel--exploracao .seletor-de-feicoes .feicoes {
  border-top-color: rgba(255, 255, 255, 0.16);
}

.nivel--exploracao .seletor-de-feicoes .feicoes__item {
  border-bottom-color: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.88);
}

.nivel--exploracao .seletor-de-feicoes .feicoes__item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.nivel--exploracao .seletor-de-feicoes .feicoes__item[data-selecionado='sim'] {
  background: rgba(245, 220, 132, 0.18);
  border-left-color: #f5dc84;
}

.nivel--exploracao .seletor-de-feicoes .feicoes__item input[type='checkbox'] {
  accent-color: #f5dc84;
}

.nivel--exploracao .seletor-de-feicoes .feicoes__detalhe {
  color: rgba(255, 255, 255, 0.62);
}

.nivel--exploracao .seletor-de-feicoes .feicoes__item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  min-width: 0;
  padding: 10px 8px;
}

.nivel--exploracao .seletor-de-feicoes .feicoes__checkbox {
  flex: 0 0 auto;
  align-self: center;
}

.nivel--exploracao .seletor-de-feicoes .feicoes__info {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  overflow: hidden;
}

.nivel--exploracao .seletor-de-feicoes .feicoes__titulo {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.94);
}

.nivel--exploracao .seletor-de-feicoes .feicoes__detalhe {
  display: block;
  font-family: var(--fonte-dados);
  font-size: 10px;
  font-weight: 400;
  line-height: 1.3;
  color: rgba(255, 255, 255, 0.52);
}

.nivel--exploracao .seletor-de-feicoes .feicoes__item .feicoes__inspecionar {
  flex: 0 0 auto;
  align-self: center;
  padding: 5px 7px;
  margin: 0;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  color: #f5dc84;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.3;
  text-decoration: none;
  cursor: pointer;
}

.nivel--exploracao .seletor-de-feicoes .feicoes__item .feicoes__inspecionar:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.10);
  border-color: rgba(255, 255, 255, 0.18);
  color: #f5dc84;
}

.nivel--exploracao .seletor-de-feicoes .feicoes__item .feicoes__inspecionar:focus-visible {
  outline: 2px solid #f5dc84;
  outline-offset: 2px;
}

.nivel--exploracao .seletor-de-feicoes .botao {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.22);
  color: rgba(255, 255, 255, 0.94);
  align-self: flex-start;
}

.nivel--exploracao .seletor-de-feicoes .botao:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.4);
}

.nivel--exploracao .seletor-de-feicoes .nota {
  color: rgba(255, 255, 255, 0.72);
}

/* --- Cabeçalho e corpo da inspeção (detalhes da feição) ----------------- */

/* Contêiner de consulta: a ficha passa a uma coluna quando o painel é estreito. */
.nivel--inspecao {
  container-type: inline-size;
  container-name: inspecao;
}

/* Bloco A — identidade. */
.nivel--inspecao .cabecalho-de-feicao {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: flex-start;
  gap: var(--espaco-3);
  padding: var(--espaco-4);
  background: rgba(255, 255, 255, 0.065);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: var(--raio-grande);
}

.nivel--inspecao .cabecalho-de-feicao__pena {
  align-self: stretch;
  width: 3px;
  border-radius: 2px;
  background: #f5dc84;
}

.nivel--inspecao .cabecalho-de-feicao__identificacao {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nivel--inspecao .cabecalho-de-feicao__camada {
  margin: 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
}

.nivel--inspecao .cabecalho-de-feicao__nome {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.3;
  color: #ffffff;
  overflow-wrap: anywhere;
}

.nivel--inspecao .cabecalho-de-feicao__id {
  margin: 0;
  font-family: var(--fonte-dados);
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: rgba(255, 255, 255, 0.6);
}

.nivel--inspecao .cabecalho-de-feicao__acoes .botao-icone {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.76);
}

.nivel--inspecao .cabecalho-de-feicao__acoes .botao-icone:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.105);
  color: #ffffff;
}

/* Bloco B — abas. */
.nivel--inspecao .inspetor__abas {
  gap: var(--espaco-4);
  padding: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.nivel--inspecao .inspetor__aba {
  min-height: 36px;
  padding: 0 2px;
  color: #ffffff;
  opacity: 0.6;
  transition: opacity var(--transicao), color var(--transicao);
}

.nivel--inspecao .inspetor__aba:hover {
  color: #ffffff;
  opacity: 0.85;
}

.nivel--inspecao .inspetor__aba[aria-selected='true'] {
  border-bottom-color: #f5dc84;
  color: #ffffff;
  opacity: 1;
}

.nivel--inspecao .inspetor__aba:focus-visible {
  outline: 2px solid #f5dc84;
  outline-offset: 2px;
}

.nivel--inspecao .inspetor__corpo {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: var(--espaco-4);
  background: rgba(255, 255, 255, 0.065);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: var(--raio-grande);
}

/* Bloco C — atributos. */
.nivel--inspecao .ficha {
  gap: 0;
}

.nivel--inspecao .ficha__linha {
  display: grid;
  grid-template-columns: minmax(0, 42%) minmax(0, 58%);
  align-items: baseline;
  gap: 12px;
  padding: 11px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.09);
}

.nivel--inspecao .ficha__linha:last-child {
  border-bottom: none;
}

.nivel--inspecao .ficha dt {
  color: rgba(255, 255, 255, 0.76);
  font-size: 11px;
  overflow-wrap: anywhere;
}

.nivel--inspecao .ficha dd {
  margin: 0;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  word-break: normal;
  overflow-wrap: anywhere;
}

@container inspecao (max-width: 328px) {
  .nivel--inspecao .ficha__linha {
    grid-template-columns: minmax(0, 1fr);
    gap: 4px;
  }
}

.nivel--inspecao .ficha__json {
  overflow-x: auto;
  background: rgba(0, 0, 0, 0.24);
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: var(--espaco-3);
  border-radius: var(--raio);
  color: rgba(255, 255, 255, 0.86);
  font-weight: 400;
}

.nivel--inspecao .carregando {
  color: rgba(255, 255, 255, 0.7);
}

.nivel--inspecao .estado {
  background: rgba(0, 0, 0, 0.18);
  border-color: rgba(255, 255, 255, 0.18);
}

.nivel--inspecao .estado--erro {
  background: rgba(179, 38, 30, 0.16);
  border-color: rgba(245, 179, 173, 0.45);
}

.nivel--inspecao .estado--erro .estado__titulo {
  color: #f5b3ad;
}

.nivel--inspecao .nota {
  color: rgba(255, 255, 255, 0.66);
}

.nivel--inspecao .nivel__rodape-acoes .botao--primario {
  background: #f5dc84;
  border-color: #f5dc84;
  color: var(--verde-institucional);
}

.nivel--inspecao .nivel__rodape-acoes .botao--primario:hover {
  background: #f0d468;
  border-color: #f0d468;
}

/* --- Ferramenta Buffer --- */

.nivel--inspecao .buffer-operacional {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.nivel--inspecao .buffer-operacional__cabecalho {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.nivel--inspecao .buffer-operacional__titulo {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
}

.nivel--inspecao .buffer-operacional__descricao {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.72);
}

.nivel--inspecao .buffer-operacional__campo {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.nivel--inspecao .buffer-operacional__campo .campo__rotulo {
  color: rgba(255, 255, 255, 0.76);
  font-size: 11px;
}

.nivel--inspecao .buffer-operacional__campo .campo__entrada {
  width: 100%;
  box-sizing: border-box;
  min-height: 42px;
  padding: 9px 12px;
  background: rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--raio);
  color: #ffffff;
  font-size: 14px;
}

.nivel--inspecao .buffer-operacional__campo .campo__entrada:hover {
  border-color: rgba(255, 255, 255, 0.36);
}

.nivel--inspecao .buffer-operacional__campo .campo__entrada:focus,
.nivel--inspecao .buffer-operacional__campo .campo__entrada:focus-visible {
  border-color: #f5dc84;
  outline: none;
}

.nivel--inspecao .buffer-operacional__campo .campo__auxilio {
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
}

.nivel--inspecao .buffer-operacional__acoes {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.nivel--inspecao .buffer-operacional__acoes > .botao {
  display: inline-flex;
  width: 100%;
  min-width: 0;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  margin: 0;
  text-align: center;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: var(--raio);
  color: #ffffff;
  font-size: 12px;
}

.nivel--inspecao .buffer-operacional__acoes > .botao:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.105);
  border-color: rgba(255, 255, 255, 0.36);
}

.nivel--inspecao .buffer-operacional__acoes > .botao--primario {
  background: #f5dc84;
  border-color: #f5dc84;
  color: #123f2b;
  font-family: inherit;
  font-weight: 650;
}

.nivel--inspecao .buffer-operacional__acoes > .botao--primario:hover:not(:disabled) {
  background: #f0d468;
  border-color: #f0d468;
}

.nivel--inspecao .buffer-operacional__acoes > .botao:only-child {
  grid-column: 1 / -1;
}

.nivel--inspecao .buffer-operacional__acoes > .botao:focus-visible {
  outline: 2px solid #f5dc84;
  outline-offset: 2px;
}

.nivel--inspecao .buffer-operacional__resultado {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.065);
  border: 1px solid rgba(245, 220, 132, 0.32);
  border-radius: var(--raio-grande);
}

/* --- Estilos do relevo dentro do painel -------------------------------- */

.painel-seccionado .relevo {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-3);
}

.painel-seccionado .relevo__controles {
  color: rgba(255, 255, 255, 0.86);
}

.painel-seccionado input[type='range'] {
  accent-color: #f5dc84;
}

.painel-seccionado input[type='checkbox'] {
  accent-color: #f5dc84;
}

/* --- Legenda dentro do rodapé do painel --------------------------------- */

.painel-exploracao__rodape .legenda {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.86);
  flex-wrap: wrap;
}

.painel-exploracao__rodape .legenda__item {
  color: rgba(255, 255, 255, 0.82);
}

/* --- Níveis coexistentes (lista preservada durante inspeção) ----------- */

.nivel-estado {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.nivel-estado__camada {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.nivel-estado__camada[hidden] {
  display: none;
}

/* --- Recolhimento do painel -------------------------------------------- */

.painel-exploracao__reabrir {
  position: absolute;
  z-index: 6;
  top: var(--espaco-3);
  right: var(--espaco-3);
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  padding: var(--espaco-2) var(--espaco-4);
  background: var(--verde-institucional);
  border: 1px solid var(--linha-forte);
  border-radius: var(--raio);
  color: var(--tinta-invertida);
  cursor: pointer;
  box-shadow: var(--sombra-flutuante);
  font-size: var(--texto-sm);
  font-weight: 600;
  transition: background var(--transicao);
}

.painel-exploracao__reabrir:hover {
  background: color-mix(in srgb, var(--verde-institucional) 80%, black);
}

.painel-exploracao__reabrir svg {
  width: 14px;
  height: 14px;
}

/* --- Configurações inline do cartão de exploração ---------------------- */

.ficha-camada__configuracoes {
  padding-top: var(--espaco-3);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  margin-top: 0;
}

/* --- Responsividade ------------------------------------------------------ */

@media (max-width: 1280px) {
  .painel-exploracao {
    width: 360px;
  }
}

@media (max-width: 900px) {
  .painel-exploracao {
    width: min(300px, 100%);
  }
}

@media (max-width: 760px) {
  .painel-exploracao {
    width: 100%;
    max-width: 100%;
    left: 0;
    right: 0;
    border-left: none;
    box-shadow: -4px 0 16px rgba(15, 35, 26, 0.14);
  }

  .exploracao__cabecalho {
    padding: 12px;
    gap: 8px;
  }

  .exploracao__titulo {
    font-size: 14px;
    overflow-wrap: anywhere;
  }

  .painel-exploracao__corpo {
    padding-left: 12px;
    padding-right: 12px;
  }

  .painel-exploracao__rodape {
    padding: 8px 12px;
  }
}

/* Recorte espacial: filtra a consulta de feições pela área visível do mapa. */
.recorte-espacial {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-1);
  padding: var(--espaco-2) var(--espaco-3);
  background: var(--papel-2);
  border: 1px solid var(--linha);
  border-radius: var(--raio);
}

.recorte-espacial__titulo {
  margin: 0;
  font-size: var(--texto-sm);
  font-weight: 700;
  color: var(--verde-institucional);
}

.recorte-espacial__texto,
.recorte-espacial__ativo,
.recorte-espacial__erro {
  margin: 0;
  font-size: var(--texto-xs);
  color: var(--tinta-media);
}

.recorte-espacial__acoes {
  display: flex;
  flex-wrap: wrap;
  gap: var(--espaco-2);
}

/*
 * Botões do recorte: \`.nivel--exploracao .seletor-de-feicoes .botao\` (painel escuro) define texto
 * claro e fundo translúcido, e seu \`:hover:not(:disabled)\` tem especificidade 0,5,0. Os seletores
 * abaixo têm uma classe a mais (0,4,0 / 0,6,0 no hover) e vêm depois, então prevalecem sem !important.
 */
.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao {
  flex: 1 1 auto;
  min-width: 0;
  align-self: auto;
  font-weight: 600;
}

.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao--primario {
  background: #123f2b;
  border-color: #123f2b;
  color: #ffffff;
}

.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao--primario:hover:not(:disabled) {
  background: #1f6846;
  border-color: #1f6846;
  color: #ffffff;
}

.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao--secundario {
  background: #ffffff;
  border-color: #83a992;
  color: #123f2b;
}

.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao--secundario:hover:not(:disabled) {
  background: #e9f0e8;
  border-color: #123f2b;
  color: #123f2b;
}

.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao:focus-visible {
  outline: 2px solid #2a8a5f;
  outline-offset: 2px;
}

.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.recorte-espacial__resultado {
  color: var(--tinta);
  font-weight: 600;
}

.recorte-espacial__ativo {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.recorte-espacial__ativo strong {
  color: var(--verde-primario);
}

.recorte-espacial__nota {
  color: var(--tinta-suave);
}

.recorte-espacial__erro {
  color: var(--erro);
}

/* --- Exportação de resultados (ações secundárias) --- */

.exportacao-csv {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--espaco-2);
}

.nivel--exploracao .seletor-de-feicoes .exportacao-csv .exportacao-csv__botao {
  align-self: auto;
  min-height: 30px;
  padding: 4px 10px;
  background: #ffffff;
  border: 1px solid #83a992;
  color: #123f2b;
  font-size: 12px;
  font-weight: 600;
}

.nivel--exploracao .seletor-de-feicoes .exportacao-csv .exportacao-csv__botao:hover:not(:disabled) {
  background: #e9f0e8;
  border-color: #123f2b;
}

.nivel--exploracao .seletor-de-feicoes .exportacao-csv .exportacao-csv__botao:focus-visible {
  outline: 2px solid #2a8a5f;
  outline-offset: 2px;
}

.nivel--exploracao .seletor-de-feicoes .exportacao-csv .exportacao-csv__botao:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.exportacao-csv__nota {
  flex: 1 1 140px;
  color: var(--tinta-suave);
  font-size: 11px;
  line-height: 1.4;
}

/* Painel de inspeção é escuro: o botão secundário usa contorno claro sobre fundo transparente. */
.nivel--inspecao .nivel__rodape-acoes .exportacao-geojson__botao {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.55);
  color: #ffffff;
  font-weight: 600;
}

.nivel--inspecao .nivel__rodape-acoes .exportacao-geojson__botao:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.14);
  border-color: #ffffff;
}

.nivel--inspecao .nivel__rodape-acoes .exportacao-geojson__botao:focus-visible {
  outline: 2px solid #f5dc84;
  outline-offset: 2px;
}

.nivel--inspecao .nivel__rodape-acoes .exportacao-geojson__botao:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/styles/exploracao.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb;;;;KAIG;EACH,6BAA6B;EAC7B,qDAAqD;EACrD,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,wCAAwC;EACxC,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA,6EAA6E;;AAE7E;EACE,UAAU;EACV,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,uDAAuD;EACvD,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2CAA2C;EAC3C,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,2CAA2C;EAC3C,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;EACf,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,sCAAsC;EACtC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA,4EAA4E;;AAE5E;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,yFAAyF;AACzF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,sCAAsC;EACtC,2CAA2C;EAC3C,iCAAiC;EACjC,cAAc;EACd,sEAAsE;AACxE;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,2CAA2C;EAC3C,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8FAA8F;EAC9F,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,uCAAuC;EACvC,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;EAC/B,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,sCAAsC;EACtC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,2CAA2C;EAC3C,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,4EAA4E;;AAE5E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,sCAAsC;EACtC,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,4BAA4B;EAC5B,+BAA+B;EAC/B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,sCAAsC;EACtC,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,6EAA6E;;AAE7E,kFAAkF;AAClF;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,+CAA+C;EAC/C,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,sCAAsC;EACtC,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,YAAY;EACZ,4DAA4D;AAC9D;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,sCAAsC;EACtC,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA,yBAAyB;AACzB;EACE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,qCAAqC;IACrC,QAAQ;EACV;AACF;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,wBAAwB;EACxB,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,0CAA0C;EAC1C,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,2CAA2C;EAC3C,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,sCAAsC;EACtC,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA,4EAA4E;;AAE5E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,6EAA6E;;AAE7E;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,4EAA4E;;AAE5E;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,4EAA4E;;AAE5E;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,sCAAsC;EACtC,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,4EAA4E;;AAE5E;EACE,4BAA4B;EAC5B,+CAA+C;EAC/C,aAAa;AACf;;AAEA,8EAA8E;;AAE9E;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,8CAA8C;EAChD;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;EACxC,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;;EAGE,SAAS;EACT,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;;EAIE;AACF;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yDAAyD;;AAEzD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iGAAiG;AACjG;EACE,uBAAuB;EACvB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":["/*\r\n * Painel de exploração territorial premium.\r\n *\r\n * Especificações:\r\n *   - Verde institucional profundo, cobrindo toda a altura do mapa.\r\n *   - Mapa permanece montado durante toda a navegação contextual.\r\n *   - Cartões premium para catálogo, lista de feições e atributos.\r\n *   - Estruturalmente preparado para modos temporais sem renderizá-los.\r\n */\r\n\r\n.painel-exploracao {\r\n  position: absolute;\r\n  z-index: 6;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  width: min(var(--largura-exploracao), 100%);\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  background: linear-gradient(\r\n      180deg,\r\n      var(--painel-exploracao-fundo) 0%,\r\n      var(--painel-exploracao-fundo-2) 100%\r\n    );\r\n  color: var(--tinta-invertida);\r\n  border-left: 1px solid var(--painel-exploracao-linha);\r\n  box-shadow: -8px 0 24px rgba(15, 35, 26, 0.18);\r\n  overflow: hidden;\r\n}\r\n\r\n.painel-exploracao__corpo {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  padding: 0 var(--espaco-4) var(--espaco-4);\r\n  scrollbar-gutter: stable;\r\n}\r\n\r\n.painel-exploracao__rodape {\r\n  flex: none;\r\n  padding: var(--espaco-3) var(--espaco-4);\r\n  border-top: 1px solid var(--painel-exploracao-linha);\r\n  background: rgba(0, 0, 0, 0.18);\r\n}\r\n\r\n/* --- Cabeçalho do painel ------------------------------------------------ */\r\n\r\n.exploracao__cabecalho {\r\n  flex: none;\r\n  display: grid;\r\n  grid-template-columns: auto minmax(0, 1fr) auto;\r\n  align-items: center;\r\n  gap: var(--espaco-3);\r\n  padding: var(--espaco-4) var(--espaco-5);\r\n  border-bottom: 1px solid var(--painel-exploracao-linha);\r\n  background: rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.exploracao__voltar {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  background: rgba(255, 255, 255, 0.08);\r\n  border: 1px solid rgba(255, 255, 255, 0.16);\r\n  border-radius: var(--raio);\r\n  color: var(--tinta-invertida);\r\n  cursor: pointer;\r\n  transition: background var(--transicao);\r\n}\r\n\r\n.exploracao__voltar:hover {\r\n  background: rgba(255, 255, 255, 0.16);\r\n}\r\n\r\n.exploracao__voltar svg {\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n.exploracao__titulos {\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.exploracao__rotulo {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  margin: 0;\r\n  font-size: var(--texto-xs);\r\n  font-weight: 600;\r\n  letter-spacing: 0.12em;\r\n  text-transform: uppercase;\r\n  color: rgba(255, 255, 255, 0.62);\r\n}\r\n\r\n.exploracao__rotulo svg {\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n.exploracao__titulo {\r\n  margin: 0;\r\n  font-size: var(--texto-lg);\r\n  font-weight: 700;\r\n  letter-spacing: -0.01em;\r\n  color: var(--tinta-invertida);\r\n}\r\n\r\n.exploracao__acoes {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-1);\r\n  margin-left: auto;\r\n}\r\n\r\n.exploracao__acao {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 28px;\r\n  height: 28px;\r\n  padding: 0 var(--espaco-2);\r\n  background: transparent;\r\n  border: 1px solid rgba(255, 255, 255, 0.16);\r\n  border-radius: var(--raio);\r\n  color: rgba(255, 255, 255, 0.86);\r\n  cursor: pointer;\r\n  font-size: var(--texto-md);\r\n  transition: background var(--transicao), color var(--transicao);\r\n}\r\n\r\n.exploracao__acao:hover {\r\n  background: rgba(255, 255, 255, 0.12);\r\n  color: var(--tinta-invertida);\r\n}\r\n\r\n/* --- Níveis genéricos --------------------------------------------------- */\r\n\r\n.nivel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-4);\r\n  padding-top: var(--espaco-4);\r\n}\r\n\r\n.nivel__cabecalho-utilitario {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-2);\r\n  padding: 12px 14px;\r\n  background: rgba(255, 255, 255, 0.055);\r\n  border: 1px solid rgba(255, 255, 255, 0.12);\r\n  border-radius: 10px;\r\n}\r\n\r\n.nivel__contador {\r\n  margin: 0;\r\n  color: rgba(255, 255, 255, 0.76);\r\n  font-size: 11px;\r\n  font-variant-numeric: tabular-nums;\r\n  font-weight: 600;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.nivel__botao-icone {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  background: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--raio);\r\n  color: rgba(255, 255, 255, 0.82);\r\n  cursor: pointer;\r\n  transition: background var(--transicao);\r\n}\r\n\r\n.nivel__botao-icone:hover {\r\n  background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.nivel__botao-icone:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.nivel__rodape-acoes {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: var(--espaco-2);\r\n  padding: var(--espaco-3) 0 var(--espaco-2);\r\n}\r\n\r\n/* --- Cartão premium de camada ------------------------------------------ */\r\n\r\n.lista-cartoes {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-4);\r\n}\r\n\r\n/* Superfície única dos cartões do painel (catálogo, ficha da camada, lista, inspeção). */\r\n.cartao-camada {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding: var(--espaco-4);\r\n  background: rgba(255, 255, 255, 0.065);\r\n  border: 1px solid rgba(255, 255, 255, 0.14);\r\n  border-radius: var(--raio-grande);\r\n  color: #ffffff;\r\n  transition: background var(--transicao), border-color var(--transicao);\r\n}\r\n\r\n.cartao-camada:hover {\r\n  background: rgba(255, 255, 255, 0.105);\r\n}\r\n\r\n.cartao-camada[data-selecionado='sim'] {\r\n  background: rgba(255, 255, 255, 0.145);\r\n  border-color: rgba(245, 220, 132, 0.58);\r\n}\r\n\r\n/* Área A — identificação. */\r\n.cartao-camada__cabecalho {\r\n  display: grid;\r\n  grid-template-columns: auto minmax(0, 1fr) auto auto;\r\n  align-items: center;\r\n  gap: 10px;\r\n  min-height: 32px;\r\n}\r\n\r\n.cartao-camada__amostra {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  cursor: pointer;\r\n}\r\n\r\n.cartao-camada__amostra input {\r\n  width: 14px;\r\n  height: 14px;\r\n  accent-color: #f5dc84;\r\n  cursor: pointer;\r\n}\r\n\r\n.cartao-camada__nome {\r\n  display: -webkit-box;\r\n  min-width: 0;\r\n  text-align: left;\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  color: #ffffff;\r\n  font: inherit;\r\n  font-size: 15px;\r\n  font-weight: 650;\r\n  line-height: 1.35;\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n  overflow-wrap: anywhere;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-line-clamp: 2;\r\n  line-clamp: 2;\r\n  transition: color var(--transicao);\r\n}\r\n\r\n.cartao-camada__nome:hover {\r\n  color: #f5dc84;\r\n}\r\n\r\n.cartao-camada__quantidade {\r\n  flex: none;\r\n  font-family: var(--fonte-dados);\r\n  font-size: 11px;\r\n  font-variant-numeric: tabular-nums;\r\n  color: rgba(255, 255, 255, 0.76);\r\n  padding: 2px var(--espaco-2);\r\n  background: rgba(0, 0, 0, 0.18);\r\n  border-radius: 999px;\r\n}\r\n\r\n.cartao-camada__expandir {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  background: transparent;\r\n  border: 1px solid rgba(255, 255, 255, 0.14);\r\n  border-radius: var(--raio);\r\n  color: rgba(255, 255, 255, 0.76);\r\n  cursor: pointer;\r\n  transition: transform var(--transicao), background var(--transicao);\r\n}\r\n\r\n.cartao-camada__expandir:hover {\r\n  background: rgba(255, 255, 255, 0.105);\r\n  color: #ffffff;\r\n}\r\n\r\n.cartao-camada[data-expandido='sim'] .cartao-camada__expandir {\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.cartao-camada__estado {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  font-size: 11px;\r\n  color: rgba(255, 255, 255, 0.76);\r\n}\r\n\r\n.cartao-camada__estado--erro {\r\n  color: #f5b3ad;\r\n}\r\n\r\n.cartao-camada__estado--aviso {\r\n  color: #f5dc84;\r\n}\r\n\r\n.cartao-camada__estado--carregando {\r\n  color: rgba(255, 255, 255, 0.76);\r\n}\r\n\r\n/* Área B — ações. */\r\n.cartao-camada__acoes {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  padding-top: 10px;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.09);\r\n}\r\n\r\n.cartao-camada__botao {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: var(--espaco-2);\r\n  min-height: 34px;\r\n  padding: 0 var(--espaco-3);\r\n  border-radius: var(--raio);\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background var(--transicao), border-color var(--transicao), color var(--transicao);\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.cartao-camada__botao svg {\r\n  width: 12px;\r\n  height: 12px;\r\n}\r\n\r\n.cartao-camada__botao--primario {\r\n  background: #f5dc84;\r\n  border-color: #f5dc84;\r\n  color: #123f2b;\r\n}\r\n\r\n.cartao-camada__botao--primario:hover {\r\n  background: #f0d468;\r\n  border-color: #f0d468;\r\n  color: #123f2b;\r\n}\r\n\r\n.cartao-camada__botao--secundario {\r\n  background: rgba(255, 255, 255, 0.065);\r\n  border-color: rgba(255, 255, 255, 0.14);\r\n  color: rgba(255, 255, 255, 0.94);\r\n}\r\n\r\n.cartao-camada__botao--secundario:hover {\r\n  background: rgba(255, 255, 255, 0.105);\r\n  border-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.cartao-camada__botao--discreto {\r\n  min-width: 34px;\r\n  background: transparent;\r\n  border-color: rgba(255, 255, 255, 0.14);\r\n  color: rgba(255, 255, 255, 0.76);\r\n  margin-left: auto;\r\n}\r\n\r\n.cartao-camada__botao--discreto:hover {\r\n  background: rgba(255, 255, 255, 0.105);\r\n  color: #ffffff;\r\n}\r\n\r\n.cartao-camada__botao:focus-visible,\r\n.cartao-camada__nome:focus-visible,\r\n.cartao-camada__expandir:focus-visible {\r\n  outline: 2px solid #f5dc84;\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* Área C — expansão. */\r\n.cartao-camada__expansao {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding-top: var(--espaco-3);\r\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.cartao-camada__expansao .configuracao-da-camada {\r\n  border-color: rgba(255, 255, 255, 0.16);\r\n}\r\n\r\n.cartao-camada__expansao .configuracao-da-camada__grupo legend {\r\n  color: rgba(255, 255, 255, 0.74);\r\n}\r\n\r\n.cartao-camada__expansao .configuracao-da-camada__grupo fieldset,\r\n.cartao-camada__expansao .configuracao-da-camada__grupo > label {\r\n  color: rgba(255, 255, 255, 0.86);\r\n}\r\n\r\n.cartao-camada__expansao .botao--texto {\r\n  color: #f5dc84;\r\n}\r\n\r\n/* --- Painel seccionado (Relevo e ferramentas) --------------------------- */\r\n\r\n.painel-seccionado {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-3);\r\n  padding: var(--espaco-4);\r\n  background: rgba(0, 0, 0, 0.18);\r\n  border: 1px solid rgba(255, 255, 255, 0.12);\r\n  border-radius: var(--raio-grande);\r\n}\r\n\r\n.painel-seccionado__cabecalho {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.painel-seccionado__titulo {\r\n  margin: 0;\r\n  font-size: var(--texto-md);\r\n  font-weight: 700;\r\n  color: var(--tinta-invertida);\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.painel-seccionado__subtitulo {\r\n  margin: 0;\r\n  font-size: var(--texto-xs);\r\n  color: rgba(255, 255, 255, 0.66);\r\n}\r\n\r\n/* --- Ordem no mapa ------------------------------------------------------ */\r\n\r\n.ordem-camadas {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-3);\r\n  padding: 12px 14px;\r\n  background: rgba(255, 255, 255, 0.065);\r\n  border: 1px solid rgba(255, 255, 255, 0.14);\r\n  border-radius: 12px;\r\n}\r\n\r\n.ordem-camadas__cabecalho {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.ordem-camadas__titulo {\r\n  margin: 0;\r\n  font-size: var(--texto-md);\r\n  font-weight: 700;\r\n  color: var(--tinta-invertida);\r\n}\r\n\r\n.ordem-camadas__subtitulo {\r\n  margin: 0;\r\n  font-size: var(--texto-xs);\r\n  color: rgba(255, 255, 255, 0.66);\r\n}\r\n\r\n.ordem-camadas__lista {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n\r\n.ordem-camadas__item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  min-width: 0;\r\n  padding: 6px 8px;\r\n  background: rgba(0, 0, 0, 0.16);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 8px;\r\n}\r\n\r\n.ordem-camadas__nome {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  color: #ffffff;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 1.3;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.ordem-camadas__botao {\r\n  flex: 0 0 auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  background: transparent;\r\n  border: 1px solid rgba(255, 255, 255, 0.14);\r\n  border-radius: var(--raio);\r\n  color: rgba(255, 255, 255, 0.82);\r\n  font-size: 14px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: background var(--transicao), color var(--transicao);\r\n}\r\n\r\n.ordem-camadas__botao:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.105);\r\n  color: #ffffff;\r\n}\r\n\r\n.ordem-camadas__botao:disabled {\r\n  opacity: 0.35;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.ordem-camadas__botao:focus-visible {\r\n  outline: 2px solid #f5dc84;\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* --- Exploração de camada ---------------------------------------------- */\r\n\r\n.ficha-camada {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding: var(--espaco-4);\r\n  background: rgba(255, 255, 255, 0.065);\r\n  border: 1px solid rgba(255, 255, 255, 0.14);\r\n  border-radius: var(--raio-grande);\r\n}\r\n\r\n.ficha-camada__cabecalho {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: var(--espaco-3);\r\n}\r\n\r\n.ficha-camada__titulos {\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.ficha-camada__rotulo {\r\n  margin: 0;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.09em;\r\n  text-transform: uppercase;\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.ficha-camada__titulo {\r\n  margin: 0;\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  line-height: 1.3;\r\n  overflow-wrap: anywhere;\r\n  color: #ffffff;\r\n}\r\n\r\n.ficha-camada__contador {\r\n  flex: none;\r\n  font-family: var(--fonte-dados);\r\n  font-size: 11px;\r\n  font-variant-numeric: tabular-nums;\r\n  padding: 2px var(--espaco-2);\r\n  background: rgba(0, 0, 0, 0.18);\r\n  border-radius: 999px;\r\n  color: rgba(255, 255, 255, 0.76);\r\n}\r\n\r\n.ficha-camada__descricao {\r\n  margin: 0;\r\n  color: rgba(255, 255, 255, 0.76);\r\n  font-size: 12px;\r\n  line-height: 1.55;\r\n}\r\n\r\n.ficha-camada__descricao + .ficha-camada__descricao {\r\n  margin-top: var(--espaco-2);\r\n}\r\n\r\n.ficha-camada__acoes {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 8px;\r\n  align-items: stretch;\r\n  padding-top: 10px;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.09);\r\n}\r\n\r\n.ficha-camada__acoes > .botao {\r\n  display: inline-flex;\r\n  width: 100%;\r\n  min-width: 0;\r\n  min-height: 40px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 8px;\r\n  margin: 0;\r\n  text-align: center;\r\n  line-height: 1.3;\r\n  white-space: normal;\r\n  border-radius: var(--raio);\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.ficha-camada__acoes .botao svg {\r\n  width: 12px;\r\n  height: 12px;\r\n}\r\n\r\n.ficha-camada__acoes .botao--secundario {\r\n  background: rgba(255, 255, 255, 0.065);\r\n  border-color: rgba(255, 255, 255, 0.14);\r\n  color: rgba(255, 255, 255, 0.94);\r\n}\r\n\r\n.ficha-camada__acoes .botao--secundario:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.105);\r\n  border-color: rgba(255, 255, 255, 0.3);\r\n  color: #ffffff;\r\n}\r\n\r\n.ficha-camada__acoes .botao--discreto {\r\n  background: transparent;\r\n  border-color: rgba(255, 255, 255, 0.14);\r\n  color: rgba(255, 255, 255, 0.76);\r\n}\r\n\r\n.ficha-camada__acoes .botao--discreto:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.105);\r\n  color: #ffffff;\r\n}\r\n\r\n.ficha-camada__acoes .botao:focus-visible {\r\n  outline: 2px solid #f5dc84;\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* --- Sobrescrita do SeletorDeFeicoes para combinar com o painel --------- */\r\n\r\n.nivel--exploracao .seletor-de-feicoes {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding: var(--espaco-4);\r\n  background: rgba(255, 255, 255, 0.065);\r\n  border: 1px solid rgba(255, 255, 255, 0.14);\r\n  border-radius: var(--raio-grande);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .camadas__alternador {\r\n  color: rgba(255, 255, 255, 0.86);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .busca .campo__entrada {\r\n  background: rgba(255, 255, 255, 0.08);\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n  color: var(--tinta-invertida);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .busca .campo__entrada::placeholder {\r\n  color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .busca__icone {\r\n  color: rgba(255, 255, 255, 0.62);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes {\r\n  border-top-color: rgba(255, 255, 255, 0.16);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__item {\r\n  border-bottom-color: rgba(255, 255, 255, 0.12);\r\n  color: rgba(255, 255, 255, 0.88);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__item:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__item[data-selecionado='sim'] {\r\n  background: rgba(245, 220, 132, 0.18);\r\n  border-left-color: #f5dc84;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__item input[type='checkbox'] {\r\n  accent-color: #f5dc84;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__detalhe {\r\n  color: rgba(255, 255, 255, 0.62);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 10px;\r\n  min-width: 0;\r\n  padding: 10px 8px;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__checkbox {\r\n  flex: 0 0 auto;\r\n  align-self: center;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__info {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__titulo {\r\n  display: block;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  line-height: 1.4;\r\n  color: rgba(255, 255, 255, 0.94);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__detalhe {\r\n  display: block;\r\n  font-family: var(--fonte-dados);\r\n  font-size: 10px;\r\n  font-weight: 400;\r\n  line-height: 1.3;\r\n  color: rgba(255, 255, 255, 0.52);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__item .feicoes__inspecionar {\r\n  flex: 0 0 auto;\r\n  align-self: center;\r\n  padding: 5px 7px;\r\n  margin: 0;\r\n  background: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: 6px;\r\n  color: #f5dc84;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  line-height: 1.3;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__item .feicoes__inspecionar:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.10);\r\n  border-color: rgba(255, 255, 255, 0.18);\r\n  color: #f5dc84;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .feicoes__item .feicoes__inspecionar:focus-visible {\r\n  outline: 2px solid #f5dc84;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .botao {\r\n  background: rgba(255, 255, 255, 0.08);\r\n  border-color: rgba(255, 255, 255, 0.22);\r\n  color: rgba(255, 255, 255, 0.94);\r\n  align-self: flex-start;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .botao:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.16);\r\n  border-color: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .nota {\r\n  color: rgba(255, 255, 255, 0.72);\r\n}\r\n\r\n/* --- Cabeçalho e corpo da inspeção (detalhes da feição) ----------------- */\r\n\r\n/* Contêiner de consulta: a ficha passa a uma coluna quando o painel é estreito. */\r\n.nivel--inspecao {\r\n  container-type: inline-size;\r\n  container-name: inspecao;\r\n}\r\n\r\n/* Bloco A — identidade. */\r\n.nivel--inspecao .cabecalho-de-feicao {\r\n  display: grid;\r\n  grid-template-columns: auto minmax(0, 1fr) auto;\r\n  align-items: flex-start;\r\n  gap: var(--espaco-3);\r\n  padding: var(--espaco-4);\r\n  background: rgba(255, 255, 255, 0.065);\r\n  border: 1px solid rgba(255, 255, 255, 0.14);\r\n  border-radius: var(--raio-grande);\r\n}\r\n\r\n.nivel--inspecao .cabecalho-de-feicao__pena {\r\n  align-self: stretch;\r\n  width: 3px;\r\n  border-radius: 2px;\r\n  background: #f5dc84;\r\n}\r\n\r\n.nivel--inspecao .cabecalho-de-feicao__identificacao {\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.nivel--inspecao .cabecalho-de-feicao__camada {\r\n  margin: 0;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.09em;\r\n  text-transform: uppercase;\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.nivel--inspecao .cabecalho-de-feicao__nome {\r\n  margin: 0;\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  line-height: 1.3;\r\n  color: #ffffff;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.nivel--inspecao .cabecalho-de-feicao__id {\r\n  margin: 0;\r\n  font-family: var(--fonte-dados);\r\n  font-size: 11px;\r\n  font-variant-numeric: tabular-nums;\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.nivel--inspecao .cabecalho-de-feicao__acoes .botao-icone {\r\n  background: transparent;\r\n  border: 1px solid rgba(255, 255, 255, 0.14);\r\n  color: rgba(255, 255, 255, 0.76);\r\n}\r\n\r\n.nivel--inspecao .cabecalho-de-feicao__acoes .botao-icone:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.105);\r\n  color: #ffffff;\r\n}\r\n\r\n/* Bloco B — abas. */\r\n.nivel--inspecao .inspetor__abas {\r\n  gap: var(--espaco-4);\r\n  padding: 0;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.nivel--inspecao .inspetor__aba {\r\n  min-height: 36px;\r\n  padding: 0 2px;\r\n  color: #ffffff;\r\n  opacity: 0.6;\r\n  transition: opacity var(--transicao), color var(--transicao);\r\n}\r\n\r\n.nivel--inspecao .inspetor__aba:hover {\r\n  color: #ffffff;\r\n  opacity: 0.85;\r\n}\r\n\r\n.nivel--inspecao .inspetor__aba[aria-selected='true'] {\r\n  border-bottom-color: #f5dc84;\r\n  color: #ffffff;\r\n  opacity: 1;\r\n}\r\n\r\n.nivel--inspecao .inspetor__aba:focus-visible {\r\n  outline: 2px solid #f5dc84;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.nivel--inspecao .inspetor__corpo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding: var(--espaco-4);\r\n  background: rgba(255, 255, 255, 0.065);\r\n  border: 1px solid rgba(255, 255, 255, 0.14);\r\n  border-radius: var(--raio-grande);\r\n}\r\n\r\n/* Bloco C — atributos. */\r\n.nivel--inspecao .ficha {\r\n  gap: 0;\r\n}\r\n\r\n.nivel--inspecao .ficha__linha {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 42%) minmax(0, 58%);\r\n  align-items: baseline;\r\n  gap: 12px;\r\n  padding: 11px 0;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.09);\r\n}\r\n\r\n.nivel--inspecao .ficha__linha:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.nivel--inspecao .ficha dt {\r\n  color: rgba(255, 255, 255, 0.76);\r\n  font-size: 11px;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.nivel--inspecao .ficha dd {\r\n  margin: 0;\r\n  color: #ffffff;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  text-align: left;\r\n  word-break: normal;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n@container inspecao (max-width: 328px) {\r\n  .nivel--inspecao .ficha__linha {\r\n    grid-template-columns: minmax(0, 1fr);\r\n    gap: 4px;\r\n  }\r\n}\r\n\r\n.nivel--inspecao .ficha__json {\r\n  overflow-x: auto;\r\n  background: rgba(0, 0, 0, 0.24);\r\n  border: 1px solid rgba(255, 255, 255, 0.12);\r\n  padding: var(--espaco-3);\r\n  border-radius: var(--raio);\r\n  color: rgba(255, 255, 255, 0.86);\r\n  font-weight: 400;\r\n}\r\n\r\n.nivel--inspecao .carregando {\r\n  color: rgba(255, 255, 255, 0.7);\r\n}\r\n\r\n.nivel--inspecao .estado {\r\n  background: rgba(0, 0, 0, 0.18);\r\n  border-color: rgba(255, 255, 255, 0.18);\r\n}\r\n\r\n.nivel--inspecao .estado--erro {\r\n  background: rgba(179, 38, 30, 0.16);\r\n  border-color: rgba(245, 179, 173, 0.45);\r\n}\r\n\r\n.nivel--inspecao .estado--erro .estado__titulo {\r\n  color: #f5b3ad;\r\n}\r\n\r\n.nivel--inspecao .nota {\r\n  color: rgba(255, 255, 255, 0.66);\r\n}\r\n\r\n.nivel--inspecao .nivel__rodape-acoes .botao--primario {\r\n  background: #f5dc84;\r\n  border-color: #f5dc84;\r\n  color: var(--verde-institucional);\r\n}\r\n\r\n.nivel--inspecao .nivel__rodape-acoes .botao--primario:hover {\r\n  background: #f0d468;\r\n  border-color: #f0d468;\r\n}\r\n\r\n/* --- Ferramenta Buffer --- */\r\n\r\n.nivel--inspecao .buffer-operacional {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  min-width: 0;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__cabecalho {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__titulo {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__descricao {\r\n  margin: 0;\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n  color: rgba(255, 255, 255, 0.72);\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__campo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  width: 100%;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__campo .campo__rotulo {\r\n  color: rgba(255, 255, 255, 0.76);\r\n  font-size: 11px;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__campo .campo__entrada {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  min-height: 42px;\r\n  padding: 9px 12px;\r\n  background: rgba(0, 0, 0, 0.18);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: var(--raio);\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__campo .campo__entrada:hover {\r\n  border-color: rgba(255, 255, 255, 0.36);\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__campo .campo__entrada:focus,\r\n.nivel--inspecao .buffer-operacional__campo .campo__entrada:focus-visible {\r\n  border-color: #f5dc84;\r\n  outline: none;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__campo .campo__auxilio {\r\n  color: rgba(255, 255, 255, 0.6);\r\n  font-size: 11px;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__acoes {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 8px;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__acoes > .botao {\r\n  display: inline-flex;\r\n  width: 100%;\r\n  min-width: 0;\r\n  min-height: 40px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0;\r\n  text-align: center;\r\n  background: transparent;\r\n  border: 1px solid rgba(255, 255, 255, 0.22);\r\n  border-radius: var(--raio);\r\n  color: #ffffff;\r\n  font-size: 12px;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__acoes > .botao:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.105);\r\n  border-color: rgba(255, 255, 255, 0.36);\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__acoes > .botao--primario {\r\n  background: #f5dc84;\r\n  border-color: #f5dc84;\r\n  color: #123f2b;\r\n  font-family: inherit;\r\n  font-weight: 650;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__acoes > .botao--primario:hover:not(:disabled) {\r\n  background: #f0d468;\r\n  border-color: #f0d468;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__acoes > .botao:only-child {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__acoes > .botao:focus-visible {\r\n  outline: 2px solid #f5dc84;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.nivel--inspecao .buffer-operacional__resultado {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding: 16px;\r\n  background: rgba(255, 255, 255, 0.065);\r\n  border: 1px solid rgba(245, 220, 132, 0.32);\r\n  border-radius: var(--raio-grande);\r\n}\r\n\r\n/* --- Estilos do relevo dentro do painel -------------------------------- */\r\n\r\n.painel-seccionado .relevo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-3);\r\n}\r\n\r\n.painel-seccionado .relevo__controles {\r\n  color: rgba(255, 255, 255, 0.86);\r\n}\r\n\r\n.painel-seccionado input[type='range'] {\r\n  accent-color: #f5dc84;\r\n}\r\n\r\n.painel-seccionado input[type='checkbox'] {\r\n  accent-color: #f5dc84;\r\n}\r\n\r\n/* --- Legenda dentro do rodapé do painel --------------------------------- */\r\n\r\n.painel-exploracao__rodape .legenda {\r\n  background: rgba(255, 255, 255, 0.06);\r\n  border: 1px solid rgba(255, 255, 255, 0.14);\r\n  color: rgba(255, 255, 255, 0.86);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.painel-exploracao__rodape .legenda__item {\r\n  color: rgba(255, 255, 255, 0.82);\r\n}\r\n\r\n/* --- Níveis coexistentes (lista preservada durante inspeção) ----------- */\r\n\r\n.nivel-estado {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n}\r\n\r\n.nivel-estado__camada {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n}\r\n\r\n.nivel-estado__camada[hidden] {\r\n  display: none;\r\n}\r\n\r\n/* --- Recolhimento do painel -------------------------------------------- */\r\n\r\n.painel-exploracao__reabrir {\r\n  position: absolute;\r\n  z-index: 6;\r\n  top: var(--espaco-3);\r\n  right: var(--espaco-3);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  padding: var(--espaco-2) var(--espaco-4);\r\n  background: var(--verde-institucional);\r\n  border: 1px solid var(--linha-forte);\r\n  border-radius: var(--raio);\r\n  color: var(--tinta-invertida);\r\n  cursor: pointer;\r\n  box-shadow: var(--sombra-flutuante);\r\n  font-size: var(--texto-sm);\r\n  font-weight: 600;\r\n  transition: background var(--transicao);\r\n}\r\n\r\n.painel-exploracao__reabrir:hover {\r\n  background: color-mix(in srgb, var(--verde-institucional) 80%, black);\r\n}\r\n\r\n.painel-exploracao__reabrir svg {\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n/* --- Configurações inline do cartão de exploração ---------------------- */\r\n\r\n.ficha-camada__configuracoes {\r\n  padding-top: var(--espaco-3);\r\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\r\n  margin-top: 0;\r\n}\r\n\r\n/* --- Responsividade ------------------------------------------------------ */\r\n\r\n@media (max-width: 1280px) {\r\n  .painel-exploracao {\r\n    width: 360px;\r\n  }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .painel-exploracao {\r\n    width: min(300px, 100%);\r\n  }\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .painel-exploracao {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    left: 0;\r\n    right: 0;\r\n    border-left: none;\r\n    box-shadow: -4px 0 16px rgba(15, 35, 26, 0.14);\r\n  }\r\n\r\n  .exploracao__cabecalho {\r\n    padding: 12px;\r\n    gap: 8px;\r\n  }\r\n\r\n  .exploracao__titulo {\r\n    font-size: 14px;\r\n    overflow-wrap: anywhere;\r\n  }\r\n\r\n  .painel-exploracao__corpo {\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n  }\r\n\r\n  .painel-exploracao__rodape {\r\n    padding: 8px 12px;\r\n  }\r\n}\r\n\r\n/* Recorte espacial: filtra a consulta de feições pela área visível do mapa. */\r\n.recorte-espacial {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-1);\r\n  padding: var(--espaco-2) var(--espaco-3);\r\n  background: var(--papel-2);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio);\r\n}\r\n\r\n.recorte-espacial__titulo {\r\n  margin: 0;\r\n  font-size: var(--texto-sm);\r\n  font-weight: 700;\r\n  color: var(--verde-institucional);\r\n}\r\n\r\n.recorte-espacial__texto,\r\n.recorte-espacial__ativo,\r\n.recorte-espacial__erro {\r\n  margin: 0;\r\n  font-size: var(--texto-xs);\r\n  color: var(--tinta-media);\r\n}\r\n\r\n.recorte-espacial__acoes {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: var(--espaco-2);\r\n}\r\n\r\n/*\r\n * Botões do recorte: `.nivel--exploracao .seletor-de-feicoes .botao` (painel escuro) define texto\r\n * claro e fundo translúcido, e seu `:hover:not(:disabled)` tem especificidade 0,5,0. Os seletores\r\n * abaixo têm uma classe a mais (0,4,0 / 0,6,0 no hover) e vêm depois, então prevalecem sem !important.\r\n */\r\n.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  align-self: auto;\r\n  font-weight: 600;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao--primario {\r\n  background: #123f2b;\r\n  border-color: #123f2b;\r\n  color: #ffffff;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao--primario:hover:not(:disabled) {\r\n  background: #1f6846;\r\n  border-color: #1f6846;\r\n  color: #ffffff;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao--secundario {\r\n  background: #ffffff;\r\n  border-color: #83a992;\r\n  color: #123f2b;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao--secundario:hover:not(:disabled) {\r\n  background: #e9f0e8;\r\n  border-color: #123f2b;\r\n  color: #123f2b;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao:focus-visible {\r\n  outline: 2px solid #2a8a5f;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .recorte-espacial .recorte-espacial__botao:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.recorte-espacial__resultado {\r\n  color: var(--tinta);\r\n  font-weight: 600;\r\n}\r\n\r\n.recorte-espacial__ativo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.recorte-espacial__ativo strong {\r\n  color: var(--verde-primario);\r\n}\r\n\r\n.recorte-espacial__nota {\r\n  color: var(--tinta-suave);\r\n}\r\n\r\n.recorte-espacial__erro {\r\n  color: var(--erro);\r\n}\r\n\r\n/* --- Exportação de resultados (ações secundárias) --- */\r\n\r\n.exportacao-csv {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .exportacao-csv .exportacao-csv__botao {\r\n  align-self: auto;\r\n  min-height: 30px;\r\n  padding: 4px 10px;\r\n  background: #ffffff;\r\n  border: 1px solid #83a992;\r\n  color: #123f2b;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .exportacao-csv .exportacao-csv__botao:hover:not(:disabled) {\r\n  background: #e9f0e8;\r\n  border-color: #123f2b;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .exportacao-csv .exportacao-csv__botao:focus-visible {\r\n  outline: 2px solid #2a8a5f;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.nivel--exploracao .seletor-de-feicoes .exportacao-csv .exportacao-csv__botao:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.exportacao-csv__nota {\r\n  flex: 1 1 140px;\r\n  color: var(--tinta-suave);\r\n  font-size: 11px;\r\n  line-height: 1.4;\r\n}\r\n\r\n/* Painel de inspeção é escuro: o botão secundário usa contorno claro sobre fundo transparente. */\r\n.nivel--inspecao .nivel__rodape-acoes .exportacao-geojson__botao {\r\n  background: transparent;\r\n  border-color: rgba(255, 255, 255, 0.55);\r\n  color: #ffffff;\r\n  font-weight: 600;\r\n}\r\n\r\n.nivel--inspecao .nivel__rodape-acoes .exportacao-geojson__botao:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.14);\r\n  border-color: #ffffff;\r\n}\r\n\r\n.nivel--inspecao .nivel__rodape-acoes .exportacao-geojson__botao:focus-visible {\r\n  outline: 2px solid #f5dc84;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.nivel--inspecao .nivel__rodape-acoes .exportacao-geojson__botao:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
